// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2u8tI","paramInput":"JobSimulator_paramInput__3tkVw","input":"JobSimulator_input__d6dlk"};